export const alphaSpaces = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true
    }
    return /^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/.test(value);
}
export const alphaNumericNoSpaces = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true
    }
    return /^[a-zA-Z.0-9]+$/.test(value);
}
export const alphaNumericNoSpacesNotDot = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true
    }
    return /^[a-zA-Z0-9]+$/.test(value);
}
export const decimal = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true
    }
    return /^[0-9]+([.][0-9]+)?$/.test(value);
}
